import React from 'react'
import moment from 'moment'
import { AutoSizer } from 'react-virtualized'
import { List } from 'react-virtualized'
import 'react-virtualized/styles.css'

class EventDatesModal extends React.PureComponent {
  render() {
    const { modalClose, events, t, goToActivityBooking } = this.props

    const renderEventDate = ({ index, key, style }) => {
      const date = events[index]
      return (
        <div className="date-item" key={key} style={style}>
          <div className="date-item__datetime">
            <div className="date-item__datetime__date">{moment(date).format('ddd, MMM D')}</div>
            <div className="date-item__datetime__time">{moment(date).format('hh:mm A')}</div>
          </div>
          <button className="date-item__choose-btn" onClick={() => goToActivityBooking(date)}>
            {t('choose')}
          </button>
        </div>
      )
    }

    const noRenderEventDate = () => {
      return (
        <div className="date-item">
          No Dates Available
        </div>
      )
    }


    return (
      <div className="event-modal">
        <i className="modal-close" onClick={modalClose} />
        <div className="modal-body">
          <div className="date-item">
            <h1>When do you want to go?</h1>
          </div>
          <AutoSizer disableHeight>
            {({ width = 600, height = 350 }) => (
              <List
                rowCount={events.length}
                overscanRowCount={10}
                rowHeight={93}
                rowRenderer={renderEventDate}
                noRowsRenderer={noRenderEventDate}
                height={height}
                width={width}
                scrollToIndex={undefined}
              />
            )}
          </AutoSizer>
        </div>
      </div>
    )
  }
}

export default EventDatesModal



// WEBPACK FOOTER //
// src/components/Activity/EventDatesModal.jsx